module.exports = __webpack_public_path__ + "img/gift.93fe3a6a.svg";